/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { WiseConnectRequest, WiseConnectionDto, WiseDisconnectRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiWiseController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-wise-controller
   * @name FindById
   * @request GET:/api/v1/wise/connection
   */
  findById = (params: RequestParams = {}) =>
    this.http.request<WiseConnectionDto, any>({
      path: `/v1/wise/connection`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findByIdPath = '/v1/wise/connection'
  static findByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-wise-controller
   * @name Connect
   * @request POST:/api/v1/wise/connection
   */
  connect = (data: WiseConnectRequest, params: RequestParams = {}) =>
    this.http.request<WiseConnectionDto, any>({
      path: `/v1/wise/connection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static connectPath = '/v1/wise/connection'
  static connectMethod = 'POST'
  /**
   * No description
   *
   * @tags api-wise-controller
   * @name Disconnect
   * @request DELETE:/api/v1/wise/connection
   */
  disconnect = (data: WiseDisconnectRequest, params: RequestParams = {}) =>
    this.http.request<WiseConnectionDto, any>({
      path: `/v1/wise/connection`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static disconnectPath = '/v1/wise/connection'
  static disconnectMethod = 'DELETE'
}
